import { TutorialOnIcon } from '../../../../../app/assets/icons/tutorial';
import { HeaderIconButton } from '../../../../layout/components/HeaderIconButton';

export const MinitutorialOff = ({ onClick }: { onClick: any }) => (
  <HeaderIconButton Icon={TutorialOnIcon} onClick={onClick} />
);
